/* eslint-disable */
import Lockr from 'lockr';
import Onfire from 'onfire.js';
import { DEVICE, STORAGE_KEY } from '@/constants';
import { nativeFunctionParamsConstant, OS } from '@/utils/detectDevice';

const onfire = new Onfire();

const setWindowGlobal = ({
  id, token, appVersion, appName,
}) => {
  window.GLOBAL_USERINFO = {
    [STORAGE_KEY.TOKEN]: token,
    [STORAGE_KEY.STUDENT_ID]: id,
    [STORAGE_KEY.APP_VERSION]: appVersion,
    [STORAGE_KEY.APP_NAME]: appName,
  };
  console.log('window.GLOBAL_USERINFO', window.GLOBAL_USERINFO);
};

const setLocalStorage = ({
  id, token, appVersion, appName,
}) => {
  Lockr.set(STORAGE_KEY.TOKEN, token);
  Lockr.set(STORAGE_KEY.STUDENT_ID, id);
  Lockr.set(STORAGE_KEY.APP_VERSION, appVersion);
  Lockr.set(STORAGE_KEY.APP_NAME, appName);
};

window.set_webview_token = params => {
  OS.TYPE === DEVICE.PC ? setLocalStorage(params) : setWindowGlobal(params);
};
window.setTimeUpdate = ({ time }) => {
  // console.log('setTimeUpdate', time);
  onfire.emit('setTimeUpdate', { time });
};
window.endedPlay = ({ type }) => {
  type === nativeFunctionParamsConstant.RECORD
    ? onfire.emit('endPlayMyRecordingUI')
    : onfire.emit('endedPlay');
};
window.startRecording = () => {
  onfire.emit('startRecording');
};
window.setReadingResult = (result) => {
  // console.log('setReadingResult', result);
  onfire.emit('setReadingResult', result);
};

window.setDownloadBookProgress = (current) => {
  onfire.emit('setDownloadBookProgress', current);
};

window.setDownloaded = ({ list }) => {
  const downloaded = list.split(',').filter(item => item);
  onfire.emit('setDownloaded', { downloaded });
};

window.audioStart = (playData) => {
  onfire.emit('audioStart', playData);
};

window.shareEnd = () => {
  onfire.emit('shareEnd');
};

window.setDownloadSoundsProgress = (current) => {
  onfire.emit('setDownloadSoundsProgress', current);
};

window.entranceBook = ({ name, pages }) => {
  // console.log('entranceBook', JSON.parse(pages));
  onfire.emit(`entrance-${name}`, JSON.parse(pages));
};

export default onfire;
